import React, { RefObject } from 'react'
import { VisibleMessage, MessageAnimType } from '../Messages'
import { getMsgByType, getMessageSize, getElByUid } from './utils'

export const animateDelCalc = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  ref: RefObject<HTMLDivElement>
) => {
  const msg = getMsgByType(visibleMessages, MessageAnimType.DEL_CALC)

  if (!msg || !ref.current) {
    return
  }

  // console.log('DEL_CALC', msg);

  const [, height] = getMessageSize(ref, msg.uid)

  const wrapperHeight = ref.current.offsetHeight
  const wrapperParentHeight = (ref.current.parentElement as HTMLDivElement)
    .offsetHeight
  const newWrapperHeight = wrapperHeight - height

  const move =
    newWrapperHeight > wrapperParentHeight
      ? Math.min(wrapperHeight + height - wrapperParentHeight, height)
      : 0
  // Math.max(Math.min(wrapperParentHeight - newWrapperHeight, height), 0);

  // jest tutaj ciągle problem z move na granicy scrolla
  // odpowiedź może być w SUGG_TO_MSG_MOVE z suggToMsg

  // console.log('DELETE');
  // console.log('wrapperHeight', wrapperHeight);
  // console.log('wrapperParentHeight', wrapperParentHeight);
  // console.log('move', move);
  // console.log('diff', wrapperParentHeight - wrapperHeight);

  const kOfEl = visibleMessages.findIndex(m => m.uid == msg.uid)

  // console.log('DEL_CALC koniec', msg);

  setVisibleMessages(
    visibleMessages.map((m, k) =>
      m.uid != msg.uid
        ? k < kOfEl
          ? {
              ...m,
              animType: MessageAnimType.MOVE,
              translate: [0, move],
            }
          : m
        : {
            ...m,
            animType: MessageAnimType.DEL_HIDE,
          }
    )
  )
}

export const animateDelHide = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  setAnimating: React.Dispatch<React.SetStateAction<boolean>>,
  ref: RefObject<HTMLDivElement>,
  scrollToBottomOffset: () => void
) => {
  const msg = getMsgByType(visibleMessages, MessageAnimType.DEL_HIDE)

  if (!msg) {
    return
  }

  // console.log('DEL_HIDE', msg);

  const el = getElByUid(ref, msg.uid)

  if (!el) {
    return
  }

  const onEnd = () => {
    // console.log('DEL_HIDE koniec');

    setVisibleMessages(
      visibleMessages
        .map(m => ({
          ...m,
          animType: MessageAnimType.NONE,
        }))
        .filter(m => m.uid != msg.uid)
    )

    setAnimating(false)
    scrollToBottomOffset()
    ;(el as HTMLDivElement).removeEventListener('animationend', onEnd)
  }

  ;(el as HTMLDivElement).addEventListener('animationend', onEnd)
}
